import { HIDE_CHATWOOT_SITE_LINKS } from 'dashboard/featureFlags';

const FEATURE_HELP_URLS = {
  agent_bots: 'https://chwt.app/hc/agent-bots',
  agents: 'https://chwt.app/hc/agents',
  audit_logs: 'https://chwt.app/hc/audit-logs',
  campaigns: 'https://chwt.app/hc/campaigns',
  canned_responses: 'https://chwt.app/hc/canned',
  channel_email: 'https://chwt.app/hc/email',
  channel_facebook: 'https://chwt.app/hc/fb',
  custom_attributes: 'https://chwt.app/hc/custom-attributes',
  dashboard_apps: 'https://chwt.app/hc/dashboard-apps',
  help_center: 'https://chwt.app/hc/help-center',
  inboxes: 'https://chwt.app/hc/inboxes',
  integrations: 'https://chwt.app/hc/integrations',
  labels: 'https://chwt.app/hc/labels',
  macros: 'https://chwt.app/hc/macros',
  reports: 'https://chwt.app/hc/reports',
  sla: 'https://chwt.app/hc/sla',
  team_management: 'https://chwt.app/hc/teams',
  webhook: 'https://chwt.app/hc/webhooks',
  billing: 'https://chwt.app/pricing',
  saml: 'https://chwt.app/hc/saml',
  captain_billing: 'https://chwt.app/hc/captain_billing',
};

export function isChatwootSiteUrl(url) {
  return (
    typeof url === 'string' &&
    (url.includes('chwt.app') || url.includes('chatwoot.com'))
  );
}

export function getHelpUrlForFeature(featureName) {
  const url = FEATURE_HELP_URLS[featureName];
  if (HIDE_CHATWOOT_SITE_LINKS && url && isChatwootSiteUrl(url)) return null;
  return url;
}

export function shouldShowChatwootSiteLink(url) {
  if (!url) return false;
  if (!HIDE_CHATWOOT_SITE_LINKS) return true;
  return !isChatwootSiteUrl(url);
}
